export default __webpack_public_path__ + "static/img-finish-products-c4f2fbfbf1cf9f38abc99af31a0c9b92.webp";